import styled from 'styled-components';
import { colorConstants } from '../../theme/mindly_constants';

export const Fake = styled.span`
  flex-shrink: 0 !important;

  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${colorConstants.AccentDisabledColor};
  border-radius: 50%;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 8px;
    height: 8px;
    background-color: ${colorConstants.primaryColor};
    border-radius: 50%;
    opacity: 0;
    transition: 0.2s;
  }
`;

export const Radio = styled.input`
  display: none;

  &:checked + ${Fake} {
    border-color: ${colorConstants.primaryColor};
  }

  &:checked + ${Fake}::before {
    opacity: 1;
  }
`;

export const RadioButtonContainer = styled.label`
  display: flex;
  column-gap: 16px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;

  color: #5b5b5b;
`;
